<template>
  <div id="">
    <div  v-if="load_show">
      <load></load>
    </div>
    <div class="main_all">
      <div class="leftvideo left">
        <!-- 视频-->
        <el-page-header @back="$router.go(-1)" content="进行任务">
        </el-page-header>
        <el-form class="videoplay left" ref="video">
          <el-form-item prop="video" style="width: 100%">
            <div class="whole">
              <div class="player-div">
                <div class="jiyi" v-show="jiyidian">
                  <i class="el-icon-close" style="color: white;" @click="jiyidian=false"></i>
                  <span @click='quick' style="cursor: pointer;">跳转到上次播放的位置</span></div>
                <video ref="videoPlayer" class="video-js video vjs-big-play-centered" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
                </video>
              </div>
              <!-- </el-button> -->
            </div>
            <div class="below-div">
              <div @click="change_time('del')">-15S</div>
              <div @click="change_time('add')">+15S</div>
              <div @click="button_c('dz')" v-if="dz_button=='1'">已赞</div>
              <div @click="button_c('dz')" v-else>点赞</div>
              <div @click="button_c('sc')" v-if="sc_button=='1'">已收藏</div>
              <div @click="button_c('sc')" v-else>收藏</div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 侧边 -->
      <div class="rightcon right">
        <!-- 课程列表 -->
        <el-tabs
          class="box-card"
          v-model="activeName"
          @tab-click="handleClick"
          ref="card"
        >
          <el-tab-pane label=" 任务列表 " name="first">
            <div
              v-for="(val, key) in plan.list"
              :key="key"
              class="item"
              @click="change_play(val.num, val.type)"
            >
              <div v-if="val.num == play.num && val.type==play.type" class="item itemhover itemactive">
                <div class="planname">
                  <img src="../../../assets/playon.gif" style="height: 12px" />
                  {{ val.name }}
                </div>
                <div class="planstatus">
                  <p>{{ val.status }}</p>
                </div>
              </div>
              <div v-else class="item">
                <div class="planname">{{ val.name }}</div>
                <div class="planstatus">
                  <p>{{ val.status }}</p>
                </div>
              </div>
            </div>
            <el-button
              v-if="exam.stats!=0"
              style="position: absolute; bottom: 0px"
              size="medium"
              type="success"
              round
              class="addbtn"
              @click="tasksubject"
              >去考试</el-button
            >
          </el-tab-pane>

          <!-- 笔记-->
          <el-tab-pane label=" 笔记 " name="second">
            <div class="notes">
              <div v-for="(i, key) in play.note" :key="key" class="con">
                {{ i.content }}
                <p>{{ i.time }}</p>
              </div>
            </div>
            <div class="add">
              <div class="newnote" v-if="add.addnote">
                <el-input
                  v-model="add.note"
                  placeholder="请输入笔记"
                  type="textarea"
                  resize="none"
                ></el-input>

                <el-button
                  class="left"
                  size="medium"
                  type="info"
                  @click="add_btn('note')"
                  >取消</el-button
                >
                <el-button
                  class="right"
                  size="medium"
                  type="success"
                  @click="save_btn('note')"
                  >保存</el-button
                >
              </div>
              <el-button
                size="medium"
                @click="add_btn('note')"
                type="primary"
                ref="notebtn"
                class="addbtn"
                >添加笔记</el-button
              >
            </div>
          </el-tab-pane>
          <!-- 提问-->
          <el-tab-pane label=" 提问 " name="third">
            <div class="notes">
              <div v-for="(i, key) in play.question" :key="key" class="con">
                {{ i.content }}
                <p>{{ i.time }}</p>
              </div>
            </div>
            <div class="add">
              <div class="newnote" v-if="add.addqes">
                <el-input
                  v-model="add.qes"
                  placeholder="请输入问题"
                  type="textarea"
                  resize="none"
                ></el-input>
                <el-button
                  class="left"
                  size="medium"
                  type="info"
                  @click="add_btn('qes')"
                  >取消</el-button
                >
                <el-button
                  class="right"
                  size="medium"
                  type="success"
                  @click="save_btn('qes')"
                  >保存</el-button
                >
              </div>
              <el-button
                size="medium"
                @click="add_btn('qes')"
                type="primary"
                ref="qesbtn"
                class="addbtn"
                >添加问题</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="电子签名" :visible.sync="autograph.show"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()" :modal-append-to-body='false'>
      请输入您的密码: <el-input show-password v-model="autograph.input" style="margin: 1rem 0 1rem 0 ;"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autograph_click('ok')">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import load from '../../../components/load.vue';
export default {
  name: "App",
  data() {
    return {
      load_show:false,
      jiyidian:false,
      exam:{
        stats:''
      },
      dz_button:null,
      sc_button:null,
      activeName: "first",
      play:{
        info:{},
        list:[],
        note:[],
        status:false,
        check:0,
        old_time:0,
      },
      player: null,
      videoOptions: {
        // lang: 'zh-CN',
        autoplay: false,//自动播放
        controls: true,//用户可以与之交互的控件
        // loop:false,//视频一结束就重新开始
        muted:false,//默认情况下将使所有音频静音
        // aspectRatio:"16:9",//显示比率
        // preload:false,//预加载
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        errorDisplay: false,
        fluid: true,
        controlBar: {
          playToggle:true,
          volumePanel:true,
          currentTimeDisplay:true,
          progressControl:false,
        },
        sources:[{
          src: "",
          type: ""
        }],
      },
      study_time_status:null,
      plan: {
        num: this.$route.query.num,
        type: "video",
        info: {},
        list: [],
        idcard_status:'0'
        // status:false,
      },
      add: {
        type: "",
        addnote: false,
        note: "",
        addqes: false,
        qes: "",
      },
      autograph:{
        show:false,
        input:'',
      },
    };
  },
  components: {
    load:load
  },
  mounted: function () {
    this.get_task_info('');
    this.$refs.videoPlayer.addEventListener('timeupdate',this.check_study_time)
    this.$refs.videoPlayer.addEventListener('pause',this.clear_study_time_status)
    this.$refs.videoPlayer.addEventListener('ended',this.clear_study_time_status)
    this.$refs.videoPlayer.addEventListener('waiting',this.clear_study_time_status)
    this.$refs.videoPlayer.addEventListener('dispose',this.clear_study_time_status)
    this.$refs.videoPlayer.addEventListener('error',this.clear_study_time_status)
  },
  beforeDestroy() {
   this.examination=false;
  },
  methods: {
    quick(){
      let _this=this
      _this.jiyidian=false
      if(_this.play.info.quick_time!=0 && _this.player){
        _this.player.currentTime(_this.play.info.quick_time)
      }
    },
    tasksubject(){
          let _this=this
          _this.axios.post('/v2/user_task/check_task_type',{data:{'num':_this.$route.query.num,type:'train'}}).then(function(res) {
            if(res.status=='200'){
              if(res.data.code != 1){
                   _this.$message.error(res.data.msg)
              }else{
                if(res.data.data == 'video'){
                  _this.$message.error('请先完成视频观看')
                }else{
                   _this.$router.push({path:'/tasksubject',query:{num:_this.$route.query.num}})
                }
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });

        },

    change_time(type){
      let _this=this
      if(type=='add'){
        _this.player.currentTime(_this.player.currentTime()+15)
      }else{
        _this.player.currentTime(_this.player.currentTime()-15)
      }
    },

    //点赞收藏事件
    button_c(type){
      let _this=this
      if(type=="dz"){
        _this.support('support','dz_button')
      }else{
        _this.support('collect','sc_button')
      }
    },

    support(opration,button){
      let _this=this
      _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'video',type:_this.play.type,num:_this.play.num,opration:opration}}).then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            _this.$message.success(res.data.msg)
            if(opration=='support'){
              _this.dz_button=res.data.data
            }else{
              _this.sc_button=res.data.data
            }
          }else{
            _this.$message.error(res.data.msg)
          }
        }else{
          _this.$message.error('服务器内部错误')
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
      });
    },

    //初始化数据
    get_task_info(type) {
      let _this = this;
      _this.load_show=true
      _this.axios.get("/v2/user_task/get_task_info", {
          params: { type: _this.plan.type, num: _this.plan.num },
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.plan.list = res.data.data.list
              _this.plan.idcard_status=res.data.data.idcard_status
              _this.exam.stats=res.data.data.exam
              if(type==''){
                _this.play.type = res.data.data.list[0].type
                _this.play.num = res.data.data.list[0].num
                _this.exam_button= res.data.data.exam.stats
                if(res.data.data.quick_time!=0){
                  _this.jiyidian=true
                }
                _this.get_system("v")
              }
              _this.load_show=false
            } else {
              _this.$message.error(res.data.msg);
              _this.load_show=false
            }
          } else {
            _this.$message.error("服务器内部错误");
            _this.load_show=false
          }
        });
    },

    get_system(){
      let _this=this
      _this.load_show=true
      _this.axios.get('/v2/user_resource/get_system').then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            if(res.data.data.video_percentage=='1'){
              _this.videoOptions.controlBar.progressControl=true//倍数
            }
            if(res.data.data.video_multiple=='1'){
              _this.videoOptions.playbackRates=[0.5, 1,1.25,1.5,1.75,2,3]//倍数
            }
            _this.get_info('v')
          }else{
            _this.$message.error(res.data.msg)
          }
          _this.load_show=false
        }else{
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
        _this.load_show=false
      })
    },

    change_play(num,type){
      let _this=this
      if(num==_this.play.num){
        return false
      }
      _this.play.num=num
      _this.play.type=type
      _this.play.check=0
      _this.get_info('v')
    },

    //渲染列表数据
    get_info(resource) {
      let _this=this
      _this.load_show=true
      _this.play.status=false
      _this.axios.get('/v2/user_resource/get_info',{params:{type:_this.play.type,num:_this.play.num,resource:resource,train:_this.plan.num}}).then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            _this.play.info=res.data.data
            _this.dz_button=res.data.data.support
            _this.sc_button=res.data.data.collect
            _this.play.num=res.data.data.num
            _this.videoOptions.sources[0].type=res.data.data.type
            _this.play.status=true
            _this.get_node()
            _this.watch()
            _this.load_show=false
          }else{
            _this.$message.error(res.data.msg)
            _this.load_show=false
          }
        }else{
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
        _this.load_show=false
      });
    },
    //笔记
    get_node() {
      let _this=this
      _this.load_show=true
      _this.axios.get('/v2/user_resource/get_note',{params:{type:_this.play.type,num:_this.play.num}}).then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            _this.play.note=res.data.data
            _this.get_question()
            _this.load_show=false
          }else{
            _this.$message.error(res.data.msg)
            _this.load_show=false
          }
        }else{
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
        _this.load_show=false
      });
    },
    get_question(){
      let _this=this
      _this.load_show=true
      _this.axios.get('/v2/user_resource/get_question',{params:{type:_this.play.type,num:_this.play.num}}).then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            _this.play.question=res.data.data
            _this.load_show=false
          }else{
            _this.$message.error(res.data.msg)
            _this.load_show=false
          }
        }else{
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
        _this.load_show=false
      });
    },
    //渲染视频
    watch() {
      let _this=this
      _this.videoOptions.sources[0].src='/v2/user_resource/play?key='+localStorage.authorization+'&type='+_this.play.type+'&num='+_this.play.num
      _this.start_player()
    },
    start_player(){
      let _this=this
      if(_this.player){
        _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
        _this.player.load()
      }else{
        _this.$nextTick(()=>{
          _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

          })
        })
      }
    },

   check_study_time(){
     let _this=this
     if(_this.player.currentTime()==_this.play.old_time){
         clearInterval(_this.study_time_status)
         _this.study_time_status=null
     }else{
       _this.play.old_time=_this.player.currentTime()
       if(_this.study_time_status==null){
         _this.study_time_status=setInterval(()=>{
           _this.save_study_time('','')
         },5000)
       }
     }
   },

    clear_study_time_status(){
      clearInterval(this.study_time_status)
      this.study_time_status=null
    },

    save_study_time(progress,time){
      let _this=this
      let data={
        type:_this.play.type,
        num:_this.play.num,
        play_time:parseInt(_this.player.currentTime()),
        train:_this.plan.num
      }
      if(progress==''){
        data.progress=(parseInt(_this.player.currentTime())/_this.player.duration()* 100).toFixed(0)
      }else{
        data.progress=progress
      }
      if(time==''){
        data.time=5
      }else{
        data.time=time
      }
      if(data.progress>70 && _this.play.check==0 && _this.plan.idcard_status=='1'){
          _this.player.pause()
          _this.autograph.show=true
      }else{
        _this.save_study_time_end(data)
      }
    },

    autograph_click(type){
      let _this=this
      if(type=='ok'){
        if(_this.autograph.input.length==0){
          _this.$message.error('请输入密码')
          return false
        }
        let data={
          type:_this.play.type,
          num:_this.play.num,
          play_time:parseInt(_this.player.currentTime()),
          train:_this.plan.num
        }
        data.progress=(parseInt(_this.player.currentTime())/_this.player.duration()* 100).toFixed(0)
        data.time=5
        _this.axios.post('/v2/user_task/task_idcard', {data:{'num':_this.plan.num,'input':_this.autograph.input}}).then(function(res) {
          if (res.status == '200') {
            if (res.data.code == '1') {
              _this.save_study_time_end(data)
              _this.autograph.show=false
              _this.autograph.input=''
              _this.player.play()
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      }else{
          _this.autograph.show=false
          _this.autograph.input=''
      }
    },
    closeDialog(){
      this.autograph_click('')
    },

    save_study_time_end(data){
      // return
      let _this=this
      _this.axios.post('/v2/user_resource/save_study_time',{data:data}).then(function(res) {
        if(res.status=='200'){
          if(res.data.code=='1'){
            if(data.progress>70 && _this.play.check==0){
              _this.get_task_info('up')
              _this.axios.post('/v2/user_task/check_task_type',{data:{'num':_this.plan.num,type:'train'}}).then(function(res) {
                if(res.status=='200'){
                  if(res.data.code=='1'){
                    _this.play.check++
                    switch(res.data.data){
                      case "video":_this.$message.success('已完成当前视频观看');break
                      case "subject":_this.$message.success('已完成视频阅读，请前往考试');break
                      case "end":_this.$message.success('已完成当前任务');break
                      default:_this.$message.success("已完成当前视频观看");break
                    }
                  }else{
                    _this.$message({ type:'warning', message:res.data.msg,duration: 3000} );
                  }
                }else{
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });
            }
          }else{
            _this.$message.error(res.data.msg)
          }
        }else{
          _this.$message.error('服务器内部错误')
        }
      }).catch(function(error) {
        _this.$message.error('服务器内部错误')
      });
    },

    handleClick(tab, event) {},

    add_btn(type) {
      let _this = this;
      // if(!_this.play.status){
      //   return false
      // }

      _this.add.type = type;
      if (_this.add["add" + type]) {
        _this.add["add" + type] = false;
        _this.$refs[type + "btn"].$el.style.display = "inline";
      } else {
        _this.add["add" + type] = true;
        _this.$refs[type + "btn"].$el.style.display = "none";
      }
    },
    //笔记问题保存
    save_btn(type) {
      let _this = this;
      _this.load_show=true
      _this.axios
        .post("/v2/user/save_note_question", {
          data: {
            num: _this.play.num,
            type: _this.play.type,
            content: _this.add[type],
            content_type: type,
          },
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.$message.success(res.data.msg);
              _this.add[type] = "";
              _this.get_node();
              _this.load_show=false
            } else {
              _this.$message.error(res.data.msg);
              _this.load_show=false
            }
          } else {
            _this.$message.error("服务器内部错误");
            _this.load_show=false
          }
        })
        .catch(function (error) {
          _this.$message.error("服务器内部错误");
          _this.load_show=false
        });
    },
  },

};
</script>

<style scoped>
  .jiyi{
    z-index:100;
      position: absolute;
      right:1rem;
      bottom: 2rem;
      background-color: rgb(80, 79, 77);
      opacity:0.7;
      color: #00F5FF;
      padding: 0 0.5rem;
      border-radius: 0.3rem;
  }
  .below-div div{
   color: white;
   height: 100%;
   width: 60px;
   float: left;
   background-color: rgb(80, 79, 77);
   border: none;
   margin-left: 10px;
   cursor: pointer;
   display: flex;
   align-items: center; /*定义body的元素垂直居中*/
   justify-content: center; /*定义body的里的元素水平居中*/
  }
  /*点赞收藏*/
  .below-div{
      width: 100%;
      height: 40px;
      background-color: rgb(80, 79, 77);
      position:relative;
      color: white;

  }
.main_all {
  height: 100vh;
  width: 100%;
  z-index: 100;
  background-color: white;
  overflow: auto;
}

/* 视频播放 */
.leftvideo {
  width: 70%;
   padding: 20px 20px 20px 40px;
  overflow: hidden;
}

.videoplay {
  width: 100%;
  margin: 30px 0;
}

.video {
  display: block;
  height: 100%;
  position: absolute;
}

.xuanfudiv {
  position: relative;
  float: right;
  right: -50px;
  top: 50px;
  width: 320px;
  height: 30px;
  text-align: center;
  z-index: 1;

}
.xuanfudiv span{
  margin-left: 29px;
}
.whole {
  padding-bottom: 56.25%;
  height: 0;
  position: relative;
}

.el-form-item {
  padding: 0;
  margin: 0;
}

.el-form-item,
.el-form-item__content,
.whole,
.video {
  width: 100%;
}

/* 侧边*/
.rightcon {
  width: calc(30% - 80px);
  background-color: #f6f8ff;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

>>> .el-tabs__content {
  margin: 15px 0px;
}

>>> .el-tabs__nav {
  width: 100%;
  text-align: center;
}

>>> .el-tabs__item {
  width: 33.3%;
  margin: 0;
  padding: 0;
}

.item {
  padding: 9px;
}

.itemactive {
  color: #008000;
  background-color: rgba(231, 245, 255, 0.6) !important;
}

.item:hover {
  color: #008000;
  background-color: rgba(231, 245, 255, 0.3);
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  padding: 15px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
  border: 1px solid #dcdfe6;
  border-left: 0;
  border-top: 0;
  border-radius: 0px 5px 5px 0px;
  height: 100%;
  overflow-y: auto;
}

>>> .el-textarea__inner {
  min-height: 100px !important;
  margin: 10px 0;
}

.btn-h {
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px 2px;
  border-left: 0;
  border-radius: 0px 5px 5px 0px;
  background-color: rgb(0 0 0 / 12%);
}

.btn-s {
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px 2px;
  border-right: 0;
  border-radius: 5px 0px 0px 5px;
  background-color: rgb(255 255 255 / 52%);
}

.el-tab-pane {
  height: calc(100% - 156px);
  /* position:fixed;
    bottom: 20px; */
}

/* 笔记*/
.con {
  margin: 15px 0;
}

.con > p {
  font-size: smaller;
  color: lightgray;
  margin: 2px 0;
}

.notes {
  height: 100%;
  overflow: auto;
}

.newnote {
  overflow: hidden;
}

.add {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.addbtn {
  width: 100%;
  margin: 0;
}

>>> .el-tabs__content {
  height: calc(100% - 90px);
}

#pane-first {
  height: calc(100% - 40px);
  overflow: auto;
}
.planname {
  width: 80%;

  height: 40px;
}
.planstatus {
  float: right;
  color: #808080;
  font-size: small;
  line-height: 21px;

  margin: 0;
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  height: 40px;
  margin-top: -40px;
}
</style>



// WEBPACK FOOTER //
// src/view/index/Task/Taskvideo.vue